module.exports = __webpack_public_path__ + "img/Pot1.213041f6.svg";